// extracted by mini-css-extract-plugin
export default {"container":"XdwHk","list":"Gw2WM","listItem":"g7POR","listItemFavorites":"jTuRJ","arrow":"jqhSM","arrowRight":"ZBeNf","arrowLeft":"HxR2B"};